import TokenExFrame from "@eisinc/MobiusOverrides/TokenExFrame";

export default TokenExFrame;

export * from "@eisinc/MobiusOverrides/TokenExFrame";
